"use strict";

window.rdFuncs = {

    createMap__ready: function () {

        var self = this;

        self.init = function () {

            if (!document.getElementById('google-map')) return;

            var element = $('#google-map'),
                myOptions = {
                    zoom: 2,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    panControl: false,
                    zoomControl: true,
                    scaleControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    scrollwheel: false,
                    draggable: true
                },
                map = new google.maps.Map(document.getElementById("google-map"), myOptions),
                infowindow = new google.maps.InfoWindow(),
                bounds = new google.maps.LatLngBounds(),
                image = new google.maps.MarkerImage( rd_scripts.url + '/assets/img/map-icon.png',
                    new google.maps.Size(40, 57)
                );

            if ($('.js-markers').length > 0) {

                $('.js-markers').each(function (i, elem) {

                    var get_image = $(elem).data('image'),
                        get_lat = $(elem).data('lat'),
                        get_lng = $(elem).data('lng'),
                        get_url = $(elem).data('url');

                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(get_lat, get_lng),
                        map: map,
                        url: get_url,
                        icon: get_image,
                        animation: google.maps.Animation.DROP
                    });

                    bounds.extend(marker.position);

                    google.maps.event.addListener(marker, 'click', function () {

                        if (this.url != '') {
                            window.open(this.url, '_blank');
                        }

                    });

                });

            }

            map.setCenter({
                lat: 30,
                lng: 30
            });
            //map.fitBounds(bounds);

            google.maps.event.addDomListener(window, 'resize', function () {
                //map.fitBounds(bounds);
                map.setCenter({
                    lat: 30,
                    lng: 30
                });
            });

        };

    },

    mapScript__ready: function () {

        if (!document.getElementById('google-map')) return;

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAvhLuGogRbaJLTz5sZJLaKM4jwqTXR7kY&v=3.27&callback=rdCore.createMap.init';


        document.body.appendChild(script);

    },

    lazySizes__ready: function () {

        document.addEventListener('lazybeforeunveil', function (e) {
            var bg = e.target.getAttribute('data-bg');
            if (bg) {
                e.target.style.backgroundImage = 'url(' + bg + ')';
            }
        });

    },

    lazyload__ready: function () {

        window.lazySizesConfig = window.lazySizesConfig || {};

        window.lazySizesConfig.lazyClass = 'js-img';

        lazySizesConfig.loadMode = 1;

    },

    reveal__ready: function () {

        var self = this;

        self.init = function () {

            var scrolleffect = document.querySelectorAll('.js-hidden');

            for (var i = 0; i < scrolleffect.length; i++) {

                var visible = IsVisible.check(scrolleffect[i], -300);

                if (visible === true) {
                    $(scrolleffect[i]).addClass('is-active');
                } else {
                    $(scrolleffect[i]).removeClass('is-active');
                }

            }

        }

        // self.init();

    },

    barslider__ready: function () {

        var slider = $('.js-barslider');
        slider.zRS3({
            decimal: 1e50,
            background: true,
            speed: 1500,
            transition: 'slide',
            visibleSlides: 5,
            setVisibleSlides: {

                900: 3,
                600: 2,

            }
        });

    },

    snackbar__ready: function () {

        $('.js-snackbar-disable').on('click', function () {
            Cookies.set('snackbar', 'true');
            $('.js-snackbar').addClass('is-inactive');
            $('.js-header').addClass('l-header--fixed');

        });

    },

    cookiesBar__ready: function () {

      $( document ).ready(function() {
        if(Cookies.get('cookies-bar') === undefined) {
          $('.js-cookies-bar').removeClass('hidden');
        }
      });

      $('.js-cookies-bar-disable').on('click', function () {
          Cookies.set('cookies-bar', 'true', { expires: 31 });
          $('.js-cookies-bar').addClass('hidden');
      });
    },

    // deprecated function (delete after testing the new method)
    snackbarConditionals__ready : function() {

      var self = this;

      var target = ".js-snackbar a";
      var url_1 = window.location.href.indexOf("/dimmi");
      var url_2 = window.location.href.indexOf("/australia");
      var page_1 = "https://www.dimmi.com.au/";
      var page_2 = "https://www.resdiary.com/Search?searchText=Sydney,%20New%20South%20Wales,%20Australia&latitude=-33.8688197&longitude=151.2092955&page=1&searchDistance=10";

      this.init = function() {
        if (url_1 > 0) {
          $(target).attr('href', page_1);
        } else if (url_2 > 0) {
          $(target).attr('href', page_2);
        }
      };

      self.init();

    },

    snackbarCustomLink__ready: function() {
      var self = this;

      var target = ".js-snackbar a";
      var page = $(".js-snackbar-custom-link").text();

      this.init = function() {
        if (page.length > 0) {
          $(target).attr('href', page);
        }
      };

      self.init();
    },

    demoButtonHide__ready : function() {

      var self = this;

      var target = ".c-external";
      var urls = ["/on-site-training", "/training"];

      this.init = function() {
        urls.forEach(function(e) {
          var url = window.location.href.indexOf(e);
          if (url > 0) {
            self.hide();
          }
        });
      };

      this.hide = function() {
        $(target).hide();
      };

      self.init();
    },

    header__ready: function () {

        var self = this;
        var header = document.querySelector(".js-header");
        var barOffset = $('.js-snackbar').length ? $('.js-snackbar').height() : 0;
        var headroom = new Headroom(header, {
            offset: barOffset,
            classes: {
                initial: "l-header",
                pinned: "l-header--pinned",
                unpinned: "l-header--unpinned",
                top: "l-header--top",
                notTop: "l-header--fixed",
                bottom: "l-header--bottom",
                notBottom: "l-header--notBottom"
            }
        });

        if (Cookies.get('snackbar', 'true') != true) {
            headroom.init();
        } else {
            $('.js-header').addClass('l-header--fixed');
        }

        // Scroll down when a dropdown menu item is clicked
        $(".dropdown-toggle").click(function(e) {
          var target = e.target;

          $('.navbar').animate({
              scrollTop: target.getBoundingClientRect().top - $(".js-snackbar").height() - $(".navbar-header").height()
          }, 100);
        });

        // scroll down when the menu search bar is selected
        $(".search-field--menu").click(function(e) {
          if(window.innerWidth < 1200) {
            var target = e.target;

            $('.navbar').animate({
                scrollTop: target.getBoundingClientRect().top - $(".js-snackbar").height() - $(".navbar-header").height()
            }, 1000);
          }
        });
        // END

        this.hidePrimaryNavbar = function(path) {

          var urlPath = window.location.href.indexOf(path);
          var targetLeftNavbar = '#rd-navbar-left';

          if (urlPath > 0) {
            $(targetLeftNavbar).remove();
          }
        }

        this.resetNavbarHeight = function() {
          // If any of the navbar dropdowns are open
          // If the navbar burger is visible
          if( $(".js-header .collapse.in").length && $(".navbar-header .navbar-toggle").is(":visible") ) {
            $(".js-header").css("height", window.innerHeight + "px" );
            $(".js-header").css("backgroundColor", rd_customizer_js.main_menu_colour);
          } else {
            $(".js-header").css("height", 'initial');
            $(".js-header").css("backgroundColor", "initial");
            // push the main content based on the height of the navbar
            if ( $(".js-navbar-push").length ) {
              $(".l-main").css("marginTop", $(".js-navbar-push").height() + "px");
            }
          }
        };

        this.navbarSizing = function() {
          // Reset navbar height on load.
          self.resetNavbarHeight();

          // Reset the navbar size if window is resized
          // Detects resize event and only fire when finished (instead of several times per second)
          $(window).resize(function() {
              clearTimeout(window.resizedFinished);
              window.resizedFinished = setTimeout(function(){
                self.resetNavbarHeight();
              }, 250);
          });

          // Reset the navbar size if mobile menu is hidden
          $('.js-header').on('hidden.bs.collapse', function (e) {
              self.resetNavbarHeight();
          });

          // Reset the navbar size if mobile menu is shown
          $('.js-header').on('shown.bs.collapse', function (e) {
              self.resetNavbarHeight();
          });

          // Collapse the burger view when an anchor link is clicked
          $('.js-header a').on('click', function(e) {
            if ( $(this).attr('href').match(/#./) && $('.navbar .collapse.in').length ) {
              $(".js-header .navbar-toggle").click();
            }
          });
        }

        this.init = function() {
          self.navbarSizing();
          self.hidePrimaryNavbar('/australasia/');
        };

        self.init();


    },

    sitesDropdown__ready: function () {

      var self = this;

      var sitesDropdown = '.js-sites-dropdown';
      var sitesButton = $('.js-sites-button');
      var sitesModal = $('.js-sites-modal');

      this.init = function () {

        self.bindEvents();
      }

      this.bindEvents = function () {

        sitesButton.click(function(event) {

          //show the menus fully
          sitesModal.addClass('show');

          //now set up an event listener so that clicking anywhere outside will close the menu
          $('html').click(function(event) {
            //check up the tree of the click target to check whether user has clicked outside of menu
            if ($(event.target).parents(sitesDropdown).length==0) {
              //hide the menu
              sitesModal.removeClass('show');

              //this event listener has done its job so we can unbind it.
              $(this).unbind(event);
            }
          })

          // resize the modal if it doesn't fit in height
          if (window.innerHeight < 620) {
            sitesModal.css("minHeight", window.innerHeight - 100  + "px");
          } else {
            sitesModal.css("minHeight", 520 + "px");
          }
        });
      }

      self.init();
    },

    pricing__ready: function () {

        var self = this;

        var connect = $('.js-connect');
        var express = $('.js-express');
        var pro = $('.js-pro');
        var ultimate = $('.js-ultimate');
        var training = $('.js-training');
        var links = $('.js-links');

        this.init = function () {

          // Only load the json file once.
          if( rd_scripts.json_pricing_loaded === 'false') {
            $.getJSON(rd_scripts.url + "/assets/js/data/prices.json?ver=" + rd_scripts.json_ver, function (data) {
                self.data = data;
                self.bindEvents();
            });

            rd_scripts.json_pricing_loaded = 'true';
          }

        };

        this.bindEvents = function () {
            // check if there is a custom country pre-specified, otherwise default to uk
            var priceCountry = $(".js-pricing-default-country").html();
            var queryCountry = self.checkQueryString("country");

            // validate the query country against the db entries
            queryCountry = self.data[queryCountry] ? queryCountry : false;

            if (queryCountry) {
              queryCountry= queryCountry.toLowerCase();
              self.setDefaults(queryCountry);
              $('#countrySelect').selectpicker('val', queryCountry );
            } else if (priceCountry) {
              priceCountry = priceCountry.toLowerCase();
              self.setDefaults(priceCountry);
              $('#countrySelect').selectpicker('val', priceCountry );
            } else {
              self.setDefaults("united-kingdom");
            }

            $('#countrySelect').on('change', function () {
                self.updateElements(this.value.toLowerCase());
            });

            $('#venuesSelect').on('change', function () {
                self.updateElements($("#countrySelect").val().toLowerCase());
            });

            $(pro).find('.js-annual').click(function() {
                var currentCountry = $("#countrySelect").val().toLowerCase();
                self.updateAnnualPrice(currentCountry, pro, "pro");
                self.updateGroupDiscounts(currentCountry);
            });

            $(express).find('.js-annual').click(function() {
                var currentCountry = $("#countrySelect").val().toLowerCase();
                self.updateAnnualPrice(currentCountry, express, "express");
                self.updateGroupDiscounts(currentCountry);
            });

            $(ultimate).find('.js-annual').click(function() {
                var currentCountry = $("#countrySelect").val().toLowerCase();
                self.updateAnnualPrice(currentCountry, ultimate, "ultimate");
                self.updateGroupDiscounts(currentCountry);
            });
        };

        this.setDefaults = function (country) {
            self.updateCurrency(country);
            self.updatePrices(country);
            self.updateOffers(country);
            self.updateLinks(country);
            self.updatePackageDisplay(country);
            self.commissionPackage(country);
            self.proPackageReservations(country);
            self.updateGroupDiscounts(country);
        };

        this.updateCurrency = function (country) {
            $('.js-currency').each(function () {
                $(this).text(self.data[country].currency);
            });
        };

        this.updatePrices = function (country) {

            $(connect).find('.js-price').text(self.data[country].prices.connect);
            $(express).find('.js-price').text(self.data[country].prices.express);
            $(pro).find('.js-price').text(self.data[country].prices.pro);
            $(ultimate).find('.js-price').text(self.data[country].prices.ultimate);
            $(training).text(self.data[country].currency + self.data[country].prices.training);

            // Reset payment period text
            $(express).find('.js-period-monthly').show();
            $(express).find('.js-period-annually').hide();
            $(pro).find('.js-period-monthly').show();
            $(pro).find('.js-period-annually').hide();
            $(ultimate).find('.js-period-monthly').show();
            $(ultimate).find('.js-period-annually').hide();

            // Reset the contract text
            $(express).find('.js-contract-text').show();
            $(express).find('.js-contract-text-annually').hide();
            $(pro).find('.js-contract-text').show();
            $(pro).find('.js-contract-text-annually').hide();
            $(ultimate).find('.js-contract-text').show();
            $(ultimate).find('.js-contract-text-annually').hide();

        };

        this.updateOffers = function (country) {
          var currency = self.data[country].currency;

          // Update the Book button savings amount
          $(connect).find('.js-book-button-savings').text(currency + 20);
          // Show book button savings text only for £ and € currencies
          if ( currency === "£" || currency === "€")  {
            $('.js-currency-toggle').show();
          } else {
            $('.js-currency-toggle').hide();
          };

          // Express annual offer
          // Show if price is available and hide if not
          if (self.data[country].prices.express_annual) {
            $(express).find('.js-annual').show();
            $(express).find('.js-annual-savings').text(currency + (self.data[country].prices.express)*2);
          } else {
            $(express).find('.js-annual').hide();
          }

          // Pro annual offer
          // Show if price is available and hide if not
          if (self.data[country].prices.pro_annual) {
            $(pro).find('.js-annual').show();
            $(pro).find('.js-annual-savings').text(currency + (self.data[country].prices.pro)*2);
          } else {
            $(pro).find('.js-annual').hide();
          }

          // Ultimate annual offer
          // Show if price is available and hide if not
          if (self.data[country].prices.ultimate_annual) {
            $(ultimate).find('.js-annual').show();
            $(ultimate).find('.js-annual-savings').text(currency + (self.data[country].prices.ultimate)*2);
          } else {
            $(ultimate).find('.js-annual').hide();
          }

        };

        this.updateAnnualPrice = function (country, rd_package, name) {
          var package_name = name;
          var annual_name = name + "_annual";
          var currentPrice = $(rd_package).find('.js-price').text();
          var packagePrice = self.data[country].prices[package_name];
          var currentLink = $(rd_package).find('.js-links').attr('href');
          var packageLink = self.data[country].links[package_name];

          if (currentPrice == packagePrice) {
            $(rd_package).find('.js-price').text(self.data[country].prices[annual_name]);
            $(rd_package).find('.js-links').attr('href', self.data[country].links[annual_name]);
            // update payment period text
            $(rd_package).find('.js-period-monthly').hide();
            $(rd_package).find('.js-period-annually').show();
            // update contract period text
            $(rd_package).find('.js-contract-text').hide();
            $(rd_package).find('.js-contract-text-annually').show();
          } else {
            $(rd_package).find('.js-price').text(self.data[country].prices[package_name]);
            $(rd_package).find('.js-links').attr('href', self.data[country].links[package_name]);
            // update payment period text
            $(rd_package).find('.js-period-monthly').show();
            $(rd_package).find('.js-period-annually').hide();
            // update contract period text
            $(rd_package).find('.js-contract-text').show();
            $(rd_package).find('.js-contract-text-annually').hide();
          }

        };

        this.updatePackageDisplay = function (country) {
            /*
              Check whether we should display or hide any of the packages.
            */

            // Connect package. Hide package if link and price doesn't exist.
            if (self.data[country].links.connect && self.data[country].prices.connect) {
                $(connect).show();
            } else {
                $(connect).hide();
            }

            // Express package. Hide package if link and price doesn't exist.
            if (self.data[country].links.express && self.data[country].prices.express) {
                $(express).show();
            } else {
                $(express).hide();
            }

            // Pro package. Hide package if link and price doesn't exist.
            if (self.data[country].links.pro && self.data[country].prices.pro) {
                $(pro).show();
            } else {
                $(pro).hide();
            }

            // Ultimate package. Hide package if link and price doesn't exist.
            if (self.data[country].links.ultimate && self.data[country].prices.ultimate) {
                $(ultimate).show();
            } else {
                $(ultimate).hide();
            }
        }

        this.updateLinks = function (country) {

            $(links).removeClass('disabled');
            $(connect).find('.js-links').attr('href', self.data[country].links.connect);
            $(express).find('.js-links').attr('href', self.data[country].links.express);
            $(pro).find('.js-links').attr('href', self.data[country].links.pro);
            $(ultimate).find('.js-links').attr('href', self.data[country].links.ultimate);

        };

        this.updateGroupDiscounts = function (country) {
            var discountBox = '.js-packages-discount';
            var discountPerc = '.js-packages-discount-perc';
            var numVenues = $("#venuesSelect").val();
            var demoLink = 'https://resdiary.wufoo.eu/forms/pw7q9xz0iixscy/';

            // Reset the boxes.
            $(discountBox).hide();

            // Display different discount amount based on the venues selected.
            if (numVenues >= 2 && numVenues <= 3) {
                $(discountPerc).text('5%');
            } else if (numVenues >= 4 && numVenues <= 5) {
                $(discountPerc).text('10%');
            } else if (numVenues >= 6 && numVenues <= 9) {
                $(discountPerc).text('15%');
            } else if (numVenues >= 10) {
                $(discountPerc).text('25%');
            }

            // Display the discounts.
            if (numVenues >= 2) {
                $(express).find(discountBox).show();
                $(pro).find(discountBox).show();
                $(ultimate).find(discountBox).show();
            }

            // Update the Sign Up link to the demo form.
            if (numVenues >= 2) {
                $(express).find('.js-links').attr('href', demoLink);
                $(pro).find('.js-links').attr('href', demoLink);
                $(ultimate).find('.js-links').attr('href', demoLink);
            }

            // Update the Sign Up button text.
            if (numVenues >= 2) {
                $(express).find('.js-signup-text-demo').show();
                $(express).find('.js-signup-text').hide();
                $(pro).find('.js-signup-text-demo').show();
                $(pro).find('.js-signup-text').hide();
                $(ultimate).find('.js-signup-text-demo').show();
                $(ultimate).find('.js-signup-text').hide();
            } else {
                $(express).find('.js-signup-text-demo').hide();
                $(express).find('.js-signup-text').show();
                $(pro).find('.js-signup-text-demo').hide();
                $(pro).find('.js-signup-text').show();
                $(ultimate).find('.js-signup-text-demo').hide();
                $(ultimate).find('.js-signup-text').show();
            }
        };

        this.updateElements = function (country) {
            self.updateCurrency(country);
            self.updatePrices(country);
            self.updateOffers(country);
            self.updateLinks(country);
            self.updatePackageDisplay(country);
            self.commissionPackage(country);
            self.proPackageReservations(country);
            self.updateGroupDiscounts(country);
        };

        this.checkQueryString = function (query) {
          var getUrlParameter = function getUrlParameter(sParam) {
          var sPageURL = decodeURIComponent(window.location.search.substring(1)),
              sURLVariables = sPageURL.split('&'),
              sParameterName,
              i;

          for (i = 0; i < sURLVariables.length; i++) {
              sParameterName = sURLVariables[i].split('=');

              if (sParameterName[0] === sParam) {
                  return sParameterName[1] === undefined ? true : sParameterName[1];
              }
            }
          };

          return getUrlParameter(query);
        };

        // conditional logic for what show on RD Commision package
        this.commissionPackage = function (country) {
          var element = '.js-connect';
          var signup_link = 'https://resdiary-hkd-stripe-clone.chargify.com/subscribe/9y6kzv8kg3c5/resdiary-commission';

          if (country === 'hong-kong') {
            $(element).find('.js-pricing-title').text('RD Commission');
            $(element).find('.js-pricing-subtitle').text('Only pay for confirmed reservations');
            $(element).find('.js-price').text('0');
            $(element).find('.js-price-block').after('<p class="js-pricing-commission b-grid_block__commission">5 HKD / cover<br>with max 30 HKD / booking</p>');
            $(element).find('.js-links').attr('href', signup_link);

            $(element).find('.js-pricing-btn-secondary').hide();
            $(element).find('.js-pricing-reservations').hide();
          } else {
            $(element).find('.js-pricing-btn-secondary').show();
            $(element).find('.js-pricing-reservations').show();
            $(element).find('.js-pricing-commission').hide();
            $(element).find('.js-pricing-title').text('RD Connect');
            $(element).find('.js-pricing-subtitle').text('To give you a taster of the platform');

          }

        };

        // Conditional logic for what to show on RD Pro package's reservations text
        this.proPackageReservations = function (country) {
          var defaultElement      = '.js-pricing-reservations-default',
              altElement          = '.js-pricing-reservations-alt',
              element             = '.js-pro',
              altCountries        = ['namibia', 'south-africa', 'united-arab-emirates', 'new-zealand', 'portugal' ],
              altCountriesMatch   = false;

          // if any of the alternative text countries match, say that we will need to change them
          for (var i = 0; i < altCountries.length; i++) {
            if (country === altCountries[i]) {
              altCountriesMatch = true;
            }
          }

          // change if we had a match from the array
          if (altCountriesMatch) {
            $(element).find(altElement).show();
            $(element).find(defaultElement).hide();
          } else {
            $(element).find(altElement).hide();
            $(element).find(defaultElement).show();
          }

        };

        if ( $('.js-pricing-init').length ) {
          self.init();
        }


    },

    websitesPricing__ready: function () {

        var self = this;

        var subSimple = $('.js-simple-sub');
        var subStarter = $('.js-starter-sub');
        var subAdvanced = $('.js-advanced-sub');
        var subPremium = $('.js-premium-sub');
        var setupSimple = $('.js-simple-setup');
        var setupStarter = $('.js-starter-setup');
        var setupAdvanced = $('.js-advanced-setup');
        var setupPremium = $('.js-premium-setup');
        var signupSimple = $('.js-simple-signup');
        var signupStarter = $('.js-starer-signup');
        var signupAdvanced = $('.js-advanced-signup');
        var signupPremium = $('.js-premium-signup');
        var currency = $('.js-websites-currency');

        this.init = function () {
            $.getJSON(rd_scripts.url + "/assets/js/data/websites-prices.json?ver=" + rd_scripts.json_websites_ver, function (data) {
                self.data = data;
                self.bindEvents();
            });
        };

        this.bindEvents = function () {
            // Set the default country on country dropdown.
            self.setDefaults('united-kingdom');

            // Bind the country dropdown to update upon country selection.
            $('#websitesCountrySelect').on('change', function () {
                self.updateElements(this.value.toLowerCase());
            });

            // Set the default country if page settings block is specified.
            self.updateOnPageSettings();
        };

        this.setDefaults = function (country) {
            self.updatePrices(country);
            self.updateLinks(country);
        };

        this.updateElements = function (country) {
            self.updatePrices(country);
            self.updateLinks(country);
        };

        this.updatePrices = function (country) {
            // Update the currency.
            $(currency).text(self.data[country].currency);

            // Update the sub pricing.
            $(subSimple).text(self.data[country].sub_prices.simple);
            $(subStarter).text(self.data[country].sub_prices.starter);
            $(subAdvanced).text(self.data[country].sub_prices.advanced);
            $(subPremium).text(self.data[country].sub_prices.premium);

            // Update the setup pricing.
            $(setupSimple).text(self.data[country].setup_prices.simple);
            $(setupStarter).text(self.data[country].setup_prices.starter);
            $(setupAdvanced).text(self.data[country].setup_prices.advanced);
            $(setupPremium).text(self.data[country].setup_prices.premium);
        };

        this.updateLinks = function (country) {
            $(signupSimple).attr('href', self.data[country].links.simple);
            $(signupStarter).attr('href', self.data[country].links.starter);
            $(signupAdvanced).attr('href', self.data[country].links.advanced);
            $(signupPremium).attr('href', self.data[country].links.premium);
        };

        this.updateOnPageSettings = function () {
            var pageCountry = $('.js-pricing-default-country').text().toLowerCase();

            try {
                // Check if the country is available in the database
                self.data[pageCountry].currency.length;

                self.setDefaults(pageCountry);
                $('#websitesCountrySelect').selectpicker('val', pageCountry);
            } catch (e) {}
        };

        if ( $('.js-pricing-table-init').length ) {
            self.init();
        }
    },

    contacts__ready: function () {

        var self = this;

        var supportEmailDirect = $('.js-support-email-direct');
        var supportPhoneDirect = $('.js-support-phone-direct');
        var supportEmail = $('.js-support-email');
        var supportPhone = $('.js-support-phone');

        var salesEmailDirect = $('.js-sales-email-direct');
        var salesPhoneDirect = $('.js-sales-phone-direct');
        var salesEmail = $('.js-sales-email');
        var salesPhone = $('.js-sales-phone');

        var defaultOfficeHeading = $(".js-office-heading").text();
        var defaultOfficeAddress = $(".js-office-address").text();

        this.init = function () {

          // Only load the json file once.
          if ( rd_scripts.json_contacts_loaded === 'false') {
            $.getJSON(rd_scripts.url + "/assets/js/data/prices.json?ver=" + rd_scripts.json_ver, function (data) {
              self.data = data;
              self.bindEvents();
            });

            rd_scripts.json_contacts_loaded = 'true';
          }

        };

        this.bindEvents = function () {
            // check if there is a custom country pre-specified, otherwise default to uk
            var contactCountry = $(".js-contact-default-country").html();
            if (contactCountry) {
              self.setDefaults(contactCountry.toLowerCase());
              $('#contactSelect').selectpicker('val', contactCountry );
            } else {
              self.setDefaults("united-kingdom");
            }


            $('#contactSelect').on('change', function () {
                self.updateElements(this.value.toLowerCase());
            });
        };

        this.setDefaults = function (country) {
            self.updatePhoneNumbers(country);
            self.updateEmails(country);
            self.updateOffice(country);
        };

        this.updatePhoneNumbers = function (country) {
            $(supportPhoneDirect).text(self.data[country].phones.support);
            $(supportPhone).attr("href", "tel:" + self.data[country].phones.support_tel);
            self.checkAvailability(self.data[country].phones.support, ".js-support-phone");

            $(salesPhoneDirect).text(self.data[country].phones.sales);
            $(salesPhone).attr("href", "tel:" + self.data[country].phones.sales_tel);
            self.checkAvailability(self.data[country].phones.sales, ".js-sales-phone");
        };

        this.updateEmails = function (country) {
            $(supportEmailDirect).text(self.data[country].emails.support);
            $(supportEmail).attr("href", "mailto:" + self.data[country].emails.support);
            self.checkAvailability(self.data[country].emails.support, ".js-support-email");

            $(salesEmailDirect).text(self.data[country].emails.sales);
            $(salesEmail).attr("href", "mailto:" + self.data[country].emails.sales);
            self.checkAvailability(self.data[country].emails.sales, ".js-sales-email");
        };

        this.updateOffice = function (country) {
          var countryAvailable = self.checkDataAvailability(self.data[country].office);


          if (countryAvailable === true) {
            $(".js-office-heading").text(self.data[country].office.heading);
            $(".js-office-address").text(self.data[country].office.address);
          } else {
            $(".js-office-heading").text(defaultOfficeHeading);
            $(".js-office-address").text(defaultOfficeAddress);
          }
        };

        this.updateElements = function (country) {
            self.updatePhoneNumbers(country);
            self.updateEmails(country);
            self.updateOffice(country);
        };

        this.checkAvailability = function (data, class) {
            if (data === false) {
              $(class).hide();
            } else {
              $(class).show();
            }
        };

        this.checkDataAvailability = function (data) {
          if (data !== undefined) {
            return true;
          } else {
            return false;
          }
        };

        if ( $('.js-contact-init').length ) {
          self.init();
        }

    },

    builder__ready: function () {

      var self = this;

      var host = window.location.protocol + '//' + window.location.hostname;
      var template_url = rd_scripts.url;

      this.generatePDFlink = function() {
        // define an array to store which flyer have been selected
        var arr = [];
        var link = "";

        // get the flyers list
        $('.js-builder-output .b-builder__file ').each(function( index ) {
          //console.log( index + ": " + $( this ).text() );
          arr.push( $(this).text() + '.pdf' );
        });

        // build the link based on the input
        link = host + '/misc/brochure-builder/build' + '?selected=' + arr.join(',');

        // include the cover and back text
        if ($('.js-brochure-builder-cover').val().length > 0) {
          link += "&cover=" + $('.js-brochure-builder-cover').val().replace(/\+/g, '%2B');
          tempLink = null;
        }
        if ($('.js-brochure-builder-back').val().length > 0) {
          link += "&back=" + $('.js-brochure-builder-back').val().replace(/\+/g, '%2B');
        }

        return link;
      }

      this.updatePDFlink = function(cssClass) {
        $(cssClass).val( self.generatePDFlink() );
      }

      this.init = function() {

        // hides the placeholder element on the left column
        $(document).ready(function() {
          $('.js-builder-placeholder').hide();
        });

        // show modal with image when clicked on a feature
        $('.js-builder-feature').on('click', function(e) {
          // if the zoom in icon clicked
          if ($(e.target).attr('class') === "glyphicon glyphicon-zoom-in") {
            // get the name of the feature
            var target = $( e.currentTarget ).find('.b-builder__file ').text() + '.jpg';

            // replace the image link on the modal
            $('.js-zoomin-image').attr('src', template_url + '/assets/img/pdf-builder/' + target);

            // show modal
            $('.js-zoomin-modal').modal('show');
          }
        });

        // update the build link
        $('.js-builder-modal-validator').click(function() {

          // check that build container has images in it
          // we have 1 by default as a placeholder
          if ($('.js-builder-output').children('.js-builder-placeholder').length === 0 && $('.js-builder-output').children('.js-builder-feature').length > 0) {
            // open the modal
            $('.b-builder-form-popup').modal('show');

            // update PDF link within the hidden field
            self.updatePDFlink('form.wpcf7-form .builder-link');
          } else {
            alert("Please drag and drop at least one image from the right into the left side container");
          }

        });

        // update the brochure link if cover or back text is updated
        $('.js-brochure-builder-cover').change(function () {
          self.updatePDFlink('form.wpcf7-form .builder-link')
        });
        $('.js-brochure-builder-back').change(function () {
          self.updatePDFlink('form.wpcf7-form .builder-link')
        });

        // show modal if it is enabled in CMS
        if ( brochureBuilderData.showIntro ) {
          $('.b-builder-intro-popup').modal('show');
        }

        self.removeDragnDropImage();

      };


      this.removeDragnDropImage = function() {
        // select the target node
        var target = document.getElementById('js-dragndrop-builder');

        // create an observer instance
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            // stop observing
            observer.disconnect();

            // Remove drag and drop message
            $(".js-builder-output").css('background-image', 'none');
            // This needs to be removed so the page numbers appear correctly
            $('.js-builder-placeholder').remove();
          });

        });

        // configuration of the observer:
        var config = { attributes: false, childList: true, characterData: false };

        // pass in the target node, as well as the observer options
        observer.observe(target, config);

      };

      this.initRearrange = function() {
        var count = $('#js-dragndrop-builder.containers').children().length;
        var count_current = count;
        //console.log(count);
        $('#js-dragndrop-builder.containers').on( "click", ".js-brochure-builder-left", function(e) {
          var args = [$(this).parent().parent().index(), 'left'];
          //console.log( "init args: " + args[0] + " " + args[1] );
          $("#js-dragndrop-builder.containers").trigger("ss-shuffle", args );
          self.updateCardIndex();
        });
        $('#js-dragndrop-builder.containers').on( "click", ".js-brochure-builder-right", function(e) {
          var args = [$(this).parent().parent().index(), 'right'];
          //console.log( "init args: " + args[0] + " " + args[1] );
          $("#js-dragndrop-builder.containers").trigger("ss-shuffle", args );
          self.updateCardIndex();
        });
        $('#js-dragndrop-builder.containers').on('event', function() {
          //console.log("triggered js-build-output");
          self.updateCardIndex();
        });
      };
      self.initRearrange();

      this.updateCardIndex = function() {
        var elements = $('#js-dragndrop-builder.containers').children();

        for (var i = 0; i < elements.length; i++) {
          $(elements[i]).find('.js-brochure-builder-index').text(i+1);
        }
      };

      // initialise only if the builder is present on the page
      if ($(".js-brochure-builder").length) {
        self.init();
      }

    },


    scrollTo__ready: function () {

        var scroll = new SmoothScroll('a[href*="#"]', {
          header: '.js-header'
        });

    },

    lightbox__ready: function () {

      var self = this;
      var lightboxBlock = '.js-lightbox';

      this.init = function() {
        // Required by the lighbox plugin
        $(document).on('click', '[data-toggle="lightbox"]', function(event) { event.preventDefault(); $(this).ekkoLightbox(); });
      };

      // initialise only if the lightbox is used on the page
      if ( $(lightboxBlock).length ) {
        self.init();
      }

    }


};


window.init();
